const translations = {
    address: 'Address',
    billTo: 'Bill to',
    city: 'City',
    country: 'Country: United States',
    name: 'Name',
    state: 'State',
    zipCode: 'Zip Code'
};

export default translations;
